import request from '@/router/axios'

const firstPageStepUrl = '/sg-user-service/v1/content'

export function listStep (isLogin, lang) {
  return request({
    url: firstPageStepUrl + '/listStep',
    method: 'get',
    params: {
      langCode: lang,
      isLogin: isLogin
    }
  })
}


const findHomeCateUrl = '/sg-user-service/v1/cooperation/'

export function findHome (lang) {
  return request({
    url: findHomeCateUrl + '/findHomeObj',
    method: 'get',
    params: {
      langCode: lang
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/sigen/becomePartner.js